export default __webpack_public_path__ + "static/moon5-bf6a78a8555c65d725996c1bee9d746d.svg";